import {
  buildCompleteTransferMessage,
  buildFileChunkMessage,
  buildNoteMetadataMessage,
  buildTextMessage,
  calculateTransferProgress,
  getFileChunkCount,
} from "./transferProtocol";
import { sendChannelMessage } from "./webrtc";

const sendMetadata = async ({ channel, payload }) => {
  const message = buildNoteMetadataMessage(payload);
  await sendChannelMessage({ channel, message: buildTextMessage(message) });
};

const sendFileChunks = async ({ channel, file, onProgress }) => {
  const totalChunks = getFileChunkCount(file);
  for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex += 1) {
    await sendChannelMessage({
      channel,
      message: await buildFileChunkMessage({ file, chunkIndex, totalChunks }),
    });
    onProgress(
      calculateTransferProgress({
        receivedBytes: chunkIndex + 1,
        totalBytes: totalChunks,
      })
    );
  }
};

export const sendLocalTransfer = async ({ channel, payload, onProgress }) => {
  await sendMetadata({ channel, payload });

  if (payload.file) {
    await sendFileChunks({ channel, file: payload.file, onProgress });
  }

  await sendChannelMessage({ channel, message: buildCompleteTransferMessage() });
  onProgress(100);
};
